import React from "react";
import { Modal } from "react-bootstrap";
import "../../../assets/css/dashboard.css";
import NewUser from "../forms/Add_Chat_Group"

const AddUserChat = (props) => {
  return (
    <div>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey">Add User to Chat Group</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <NewUser/>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddUserChat;
